import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CustomToastrService {
  constructor(private toastr: ToastrService) {}

  success(message: string = 'Operation successful!', title: string = 'Success') {
    this.toastr.success(message, title, {
      timeOut: 5000,
      progressBar: true,
      closeButton: true,
      positionClass: "toaster_position"
    });
  }

  error(message: string = 'Something went wrong.', title: string = 'Error') {
    this.toastr.error(message, title, {
      timeOut: 5000,
      progressBar: true,
      closeButton: true,
      positionClass: "toaster_position"
    });
  }

  info(message: string, title: string = 'Info') {
    this.toastr.info(message, title, {
      timeOut: 5000,
      progressBar: true,
      closeButton: true,
      positionClass: "toaster_position"
    });
  }

  warning(message: string, title: string = 'Warning') {
    this.toastr.warning(message, title, {
      timeOut: 5000,
      progressBar: true,
      closeButton: true,
      positionClass: "toaster_position"
    });
  }
}